import createReducer from '../../../utils/createReducer';
import { analyticsActions } from '../../../actions';

export default createReducer(null, {
  [analyticsActions.prepareData.type]: (state, { payload }) => payload,
});
